/* Effect overlays — rendered on top of the kiwi variant. */

import type { KiwiPalette } from "../kiwiPalettes";
import type { Effect } from "@/types/kiwiSkin";

export function renderEffect(palette: KiwiPalette, effect: Effect) {
  switch (effect) {
    case "sparkle_trail":
      return (
        <>
          <rect x="28" y="4" width="2" height="2" fill={palette.accent} opacity={0.5} />
          <rect x="2" y="2" width="2" height="2" fill={palette.accent} opacity={0.35} />
          <rect x="26" y="14" width="2" height="2" fill={palette.accent} opacity={0.4} />
          <rect x="0" y="20" width="2" height="2" fill={palette.accent} opacity={0.3} />
          <rect x="30" y="22" width="2" height="2" fill={palette.accent} opacity={0.25} />
        </>
      );
    case "shadow_aura":
      return (
        <>
          {/* Dark glow around body */}
          <rect x="4" y="6" width="24" height="20" fill={palette.pupil} opacity={0.08} rx="4" />
          <rect x="2" y="8" width="28" height="16" fill={palette.pupil} opacity={0.05} rx="4" />
          {/* Dark wisps */}
          <rect x="4" y="4" width="2" height="2" fill={palette.pupil} opacity={0.12} />
          <rect x="26" y="6" width="2" height="2" fill={palette.pupil} opacity={0.1} />
        </>
      );
    case "rainbow_shimmer":
      return (
        <>
          {/* Rainbow arc fragments */}
          <rect x="2" y="2" width="2" height="1" fill="#e53935" opacity={0.3} />
          <rect x="4" y="1" width="2" height="1" fill="#ff9800" opacity={0.25} />
          <rect x="6" y="0" width="2" height="1" fill="#fdd835" opacity={0.25} />
          <rect x="8" y="0" width="2" height="1" fill="#4caf50" opacity={0.2} />
          <rect x="26" y="2" width="2" height="1" fill="#2196f3" opacity={0.25} />
          <rect x="28" y="3" width="2" height="1" fill="#9c27b0" opacity={0.2} />
          {/* Shimmer particles */}
          <rect x="0" y="14" width="1" height="1" fill="#ff9800" opacity={0.2} />
          <rect x="30" y="18" width="1" height="1" fill="#4caf50" opacity={0.2} />
        </>
      );
    case "lightning_crackle":
      return (
        <>
          {/* Lightning bolt right */}
          <rect x="28" y="4" width="2" height="2" fill={palette.accent} opacity={0.6} />
          <rect x="26" y="6" width="2" height="2" fill={palette.accent} opacity={0.5} />
          <rect x="28" y="8" width="2" height="2" fill={palette.accent} opacity={0.4} />
          <rect x="26" y="10" width="2" height="1" fill={palette.accent} opacity={0.3} />
          {/* Lightning bolt left */}
          <rect x="0" y="8" width="2" height="2" fill={palette.accent} opacity={0.4} />
          <rect x="2" y="10" width="2" height="2" fill={palette.accent} opacity={0.3} />
          <rect x="0" y="12" width="2" height="1" fill={palette.accent} opacity={0.2} />
        </>
      );
    case "holographic":
      return (
        <>
          {/* Horizontal scan lines across body */}
          <rect x="6" y="8" width="20" height="1" fill={palette.accent} opacity={0.12} />
          <rect x="6" y="12" width="20" height="1" fill={palette.highlight} opacity={0.1} />
          <rect x="6" y="16" width="20" height="1" fill={palette.accent} opacity={0.12} />
          <rect x="6" y="20" width="20" height="1" fill={palette.highlight} opacity={0.08} />
          {/* Corner data pixels */}
          <rect x="0" y="0" width="1" height="1" fill={palette.accent} opacity={0.3} />
          <rect x="31" y="0" width="1" height="1" fill={palette.accent} opacity={0.3} />
          <rect x="0" y="31" width="1" height="1" fill={palette.accent} opacity={0.2} />
          <rect x="31" y="31" width="1" height="1" fill={palette.accent} opacity={0.2} />
        </>
      );
    default:
      return null;
  }
}
